// Veille stratégique — 3 zones × 3 thématiques. Données réelles (recherche déc. 2025).
// Sources : economie.gouv.fr, impots.gouv.fr, CNIL, ANSSI, lafrenchtech.gouv.fr,
// finances.bj, GDIZ, VITIB, ANSSI CI, Agence Ecofin, KPMG. Mise à jour : déc. 2025.

export const VEILLE_UPDATED = "Décembre 2025";

const IMG = {
  frParis: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34",
  frTech: "https://images.pexels.com/photos/2901209/pexels-photo-2901209.jpeg",
  frBiz: "https://images.pexels.com/photos/739407/pexels-photo-739407.jpeg",
  bjFisc: "https://images.pexels.com/photos/8657935/pexels-photo-8657935.jpeg",
  bjTech: "https://images.unsplash.com/photo-1590674899484-d5640e854abe",
  bjBiz: "https://images.pexels.com/photos/159888/pexels-photo-159888.jpeg",
  ciFisc: "https://images.pexels.com/photos/18435332/pexels-photo-18435332.jpeg",
  ciTech: "https://images.pexels.com/photos/1125212/pexels-photo-1125212.jpeg",
  ciBiz: "https://images.pexels.com/photos/5642426/pexels-photo-5642426.jpeg",
};

export const ZONES = [
  {
    key: "france-outremer", newsKey: "france", name: "France & Outre-mer", flag: "🇫🇷",
    categories: [
      { key: "fiscalite", icon: "Landmark", image: IMG.frParis,
        title: "Fiscalité & Investissement",
        highlight: "IS 25 % · CIR 30 % · Girardin/LODEOM en Outre-mer",
        points: [
          "Impôt sur les sociétés : 25 % (taux réduit 15 % jusqu'à 42 500 € pour les PME éligibles, CA ≤ 10 M€).",
          "Crédit d'Impôt Recherche (CIR) : 30 % des dépenses R&D jusqu'à 100 M€, puis 5 % (majoré dans les DOM).",
          "Outre-mer : LODEOM, Girardin industriel (avantage fiscal ~110-120 % de la mise avec agrément), Zones Franches d'Activité.",
          "Contribution exceptionnelle temporaire sur les bénéfices des très grandes entreprises (budget 2025).",
        ] },
      { key: "tech", icon: "Cpu", image: IMG.frTech,
        title: "Écosystème Tech (IA & Cybersécurité)",
        highlight: "AI Act appliqué · CNIL autorité IA · NIS2 · Mistral AI",
        points: [
          "AI Act : premières interdictions au 02/02/2025, obligations modèles à usage général au 02/08/2025.",
          "CNIL désignée autorité de référence pour l'IA (données personnelles, biométrie).",
          "ANSSI : robustesse/résilience des systèmes IA, montée en charge des obligations NIS2.",
          "French Tech : ~5,8 Md€ levés (janv.-sept. 2025), rebond porté par de gros tours (Mistral AI).",
        ] },
      { key: "social", icon: "TrendingUp", image: IMG.frBiz,
        title: "Actualités Sociales & Entreprises",
        highlight: "Attractivité, R&D et passerelle diaspora ↔ Afrique",
        points: [
          "Écosystème mature d'investisseurs et de financements pour la R&D et l'innovation.",
          "Cadre juridique solide (droit des sociétés, propriété intellectuelle, conformité).",
          "Base idéale pour structurer les projets de la diaspora vers l'Afrique de l'Ouest.",
          "Réseaux French Tech et dispositifs d'accompagnement à l'export.",
        ] },
    ],
  },
  {
    key: "benin", newsKey: "benin", name: "Bénin", flag: "🇧🇯",
    categories: [
      { key: "fiscalite", icon: "Landmark", image: IMG.bjFisc,
        title: "Fiscalité & Investissement",
        highlight: "IS 30 % · exonérations jusqu'à 17 ans · GDIZ",
        points: [
          "Impôt sur les sociétés : taux normal 30 %.",
          "Start-ups labellisées : exonération d'IS 2 ans + -50 % la 3ᵉ (CA < 100 M FCFA).",
          "Code des investissements : avantages fiscaux/douaniers jusqu'à 17 ans + réduction patronale 50-80 %.",
          "Zone industrielle GDIZ : exonération d'IS, TVA sur intrants, droits de douane, libre rapatriement des dividendes.",
        ] },
      { key: "tech", icon: "Cpu", image: IMG.bjTech,
        title: "Écosystème Tech (IA & Cybersécurité)",
        highlight: "Stratégie Nationale IA & Mégadonnées 2023-2027",
        points: [
          "Stratégie Nationale d'IA et des Mégadonnées 2023-2027 (écosystème, innovation, compétences).",
          "Cadre réglementaire de l'IA en construction ; digitalisation avancée des services publics.",
          "Protection des données personnelles via l'APDP.",
          "Dématérialisation des marchés publics en accélération.",
        ] },
      { key: "social", icon: "TrendingUp", image: IMG.bjBiz,
        title: "Actualités Sociales & Entreprises",
        highlight: "Agritech, transformation (GDIZ) & hub portuaire",
        points: [
          "Agritech & e-agriculture, soutien à la compétitivité des MPME.",
          "Industrie de transformation orientée export (pôle GDIZ).",
          "Services numériques B2B et guichet unique de formalisation.",
          "Hub portuaire régional (Port de Cotonou) et corridors logistiques.",
        ] },
    ],
  },
  {
    key: "cote_ivoire", newsKey: "cote-ivoire", name: "Côte d'Ivoire", flag: "🇨🇮",
    categories: [
      { key: "fiscalite", icon: "Landmark", image: IMG.ciFisc,
        title: "Fiscalité & Investissement",
        highlight: "IS 25 % · zone franche VITIB à 0 % d'IS 5 ans",
        points: [
          "Impôt sur les sociétés : 25 % (30 % pour télécoms & TIC).",
          "Code des investissements : régime de déclaration (sans seuil) et régime d'agrément (avec seuils).",
          "Exonérations de droits de douane et suspension temporaire de TVA en phase d'implantation.",
          "Zone franche VITIB/ZBTIC : 0 % d'IS les 5 premières années puis 1 % (redevance 2,5 % du CA).",
        ] },
      { key: "tech", icon: "ShieldCheck", image: IMG.ciTech,
        title: "Écosystème Tech (IA & Cybersécurité)",
        highlight: "ANSSI renforcée (ordonnance 2024-950, avril 2025)",
        points: [
          "Stratégie Nationale de Cybersécurité 2021-2025 (cadre légal, capacités, infrastructures critiques).",
          "Ordonnance n°2024-950 : compétences cyber transférées de l'ARTCI à l'ANSSI (avril 2025).",
          "ANSSI : sécurisation des systèmes de l'État, réponse aux incidents, audits, certificats.",
          "Protection des données personnelles : loi n°2013-450 du 19 juin 2013.",
        ] },
      { key: "social", icon: "TrendingUp", image: IMG.ciBiz,
        title: "Actualités Sociales & Entreprises",
        highlight: "Fintech leader (Djamo, Julaya) & 1ʳᵉ économie UEMOA",
        points: [
          "Fintech : signaux forts (Djamo ~17 M$, Julaya), paiements B2B et transferts intra-UEMOA.",
          "Agritech & finance agricole : crédit scoring, assurance paramétrique climatique.",
          "IA appliquée à la finance et à l'agriculture (scoring, fraude, prévision des récoltes).",
          "Première économie de l'UEMOA (~40 % du PIB régional), hub d'innovation d'Abidjan.",
        ] },
    ],
  },
];

export const VEILLE = { market: {
  title: "Passerelle France ↔ Afrique de l'Ouest 2025",
  points: [
    "Rebond du financement des startups africaines : ~3,9-4,1 Md$ levés en 2025, fintech en tête.",
    "French Tech : ~5,8 Md€ levés (janv.-sept. 2025), IA en moteur (Mistral AI).",
    "ZLECAf : marché de 1,3 Md+ de consommateurs pour les entreprises structurées.",
  ],
} };

export const ASSISTANT_SUGGESTIONS = [
  "Compare la fiscalité des entreprises entre la France et le Bénin.",
  "Quelles sont les aides à l'investissement pour la diaspora en Côte d'Ivoire ?",
  "État des lieux de la réglementation IA en France vs Afrique de l'Ouest.",
];
